import { getModel } from '../../model/registry'
import { useEffect, useRef } from "react";
import styled from "styled-components";
import { useSnapshot } from "valtio";

import WidgetGrid from "./WidgetGrid";
import { DeadSpace } from "../mobileNav/MobileNavBar";
import * as GoIcons from 'react-icons/go'
import IconButton from "../generic/IconButton";
import { dashboardStore } from "../../state/dashboardStore";
import { media } from "../../styles/media";

import useTranslation from "../../hooks/useTranslation";

const WidgetBox = styled.div`
    display: flex;
    flex-direction: column;
    margin: 0px 0px 0px 0px
`

const GridBox = styled.div`
    display: block;
    margin: 0px 0px 0px 0px
`

// On a wide screen the title and the edit button are in the header.
const WidgetHeader = styled.div`
    display: flex;
    justify-content: space-between;

    .title {
    display:flex;
    padding: 0 0 0.5rem 0;
    font-size: 1.5rem;
    font-weight: bold;
    text-align: center;
  }

    ${media.laptop} {
        display: none;
    }
`
const WidgetActions = styled.div`
    display: flex;
    align-items: center;
    gap: 0.5rem;
`

// Shown while the layout is being edited.
const EditBar = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
    padding-bottom: 0.5rem;
`

const LinkButton = styled.button`
    background: none;
    border: none;
    padding: 0;
    font-size: var(--font-S);
    color: ${({ theme }) => theme.btn.primary};
    cursor: pointer;

    &:hover {
        text-decoration: underline;
    }
`

const MissingConfig = () => {
return  <h2>This WidgetPage is not configured. Add it to the model.</h2>
}

const WidgetPage = ({ draggable, resizable, type }) => {
  const snap = useSnapshot(dashboardStore)

  const initialData = getModel('widgetDashboardData')[type]
  const { t } = useTranslation()

  const gridRef = useRef()
  const onResetLayout = () => {
    gridRef.current.resetLayout()
  };

  const onToggleEdit = () => {
    dashboardStore.editing = !dashboardStore.editing
  }

  // While mounted the header offers its edit button; leaving ends editing.
  useEffect(() => {
    dashboardStore.editable = true
    return () => {
      dashboardStore.editable = false
      dashboardStore.editing = false
    }
  }, [])

  useEffect(() => {
    gridRef.current?.setEdit(snap.editing)
  }, [snap.editing])

  if (initialData === undefined) return <MissingConfig />

  return (
    <WidgetBox>
      <WidgetHeader>
        <h2 className="title">{t(initialData.metadata.title)}</h2>
        <WidgetActions>
          <IconButton
            icon={<GoIcons.GoGear/>}
            $variant='primary'
            clickAction={onToggleEdit}
            ariaLabel={t(initialData.metadata.editButton)}
          />
        </WidgetActions>
      </WidgetHeader>
      {snap.editing && (
        <EditBar>
          <LinkButton data-testid='dashboard.reset' onClick={onResetLayout}>
            {t(initialData.metadata.resetButton)}
          </LinkButton>
          <LinkButton data-testid='dashboard.close' onClick={() => { dashboardStore.editing = false }}>
            {t('all.dashboard.close.button')}
          </LinkButton>
        </EditBar>
      )}
      <GridBox id='GridBox'>
        <WidgetGrid
          type={type}
          ref={gridRef}
          resizable={resizable}
          draggable={draggable}
          initialData={initialData}
        >
        </WidgetGrid>
      </GridBox>
      <DeadSpace />
    </WidgetBox>
  );
};

export default WidgetPage;
